<template>
    <v-dialog v-model="show" fullscreen transition="slide-y-transition" overlay-color="#111" overlay-opacity="0.95"
        :style="`${isAndroidNative ? 'margin-top: 100px; height: 100vh;' : ''} `">
        <v-card class="analytics-wrapper">
            <v-btn variant="tonal" class="mt-6" @click="close"
                style="position: absolute; top: 1px; right: 12px; z-index: 10; background-color: #222; transition: 0.3s ease;">

                {{ $t('closeButton') }}
            </v-btn>
            <h2 class="title" style="text-align: left; margin-left: 0;">{{ $t('app.analytics') }}</h2>

            <v-container class="chart-section">
                <v-row>
                    <v-col cols="12">
                        <h3 class="subtitle">{{ $t('analytics.keyMetrics') }}</h3>
                        <ul class="analytics-list">
                            <li>{{ $t('analytics.utilization') }}</li>
                            <li>{{ $t('analytics.engagement') }}</li>
                            <li>{{ $t('analytics.peakUsage') }}</li>
                            <li>{{ $t('analytics.forecasting') }}</li>
                            <li>{{ $t('analytics.comparativeStats') }}</li>
                        </ul>
                    </v-col>

                    <v-col cols="12" md="6">
                        <apexchart type="line" height="260" :options="lineOptions" :series="lineSeries" />
                    </v-col>

                    <v-col cols="12" md="6">
                        <apexchart type="heatmap" height="260" :options="heatmapOptions" :series="heatmapSeries" />
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineExpose } from 'vue';
import ApexCharts from 'vue3-apexcharts';
import { Capacitor } from '@capacitor/core';

const isAndroidNative = Capacitor.getPlatform() === 'android' && Capacitor.isNativePlatform();

const show = ref(false);
function open() { show.value = true; }
function close() { show.value = false; }

// Example data for line chart
const lineOptions = {
    chart: { id: 'line-chart' },
    xaxis: { categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] },
    stroke: { curve: 'smooth' },
    theme: { mode: 'dark' },
};
const lineSeries = [{ name: 'Users', data: [30, 40, 35, 50, 49, 60, 70] }];

// Example data for heatmap
const heatmapOptions = {
    chart: { type: 'heatmap' },
    dataLabels: { enabled: false },
    colors: ['#00bfff'],
    theme: { mode: 'dark' },
};
const heatmapSeries = [
    { name: 'Zone A', data: [20, 29, 31, 40, 28, 51, 42] },
    { name: 'Zone B', data: [15, 18, 25, 30, 22, 35, 38] },
];

defineExpose({ open });
</script>

<style scoped>
.analytics-wrapper {
    background-color: #111;
    padding: 24px 16px;
    overflow-y: auto;
    min-height: 100vh;
    color: #fff;
    display: flex;
    flex-direction: column;
}

.close-button {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.12);
    border-radius: 50%;
    backdrop-filter: blur(4px);
}

.title {
    text-align: center;
    font-size: clamp(1.5rem, 2.5vw, 2rem);
    font-weight: bold;
    margin-bottom: 24px;
}

.subtitle {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 10px;
}

.analytics-list {
    font-size: 1rem;
    color: #ccc;
    padding-left: 1.2rem;
    margin-bottom: 2rem;
    list-style-type: disc;
    line-height: 1.6;
}

.chart-section {
    max-width: 1200px;
    margin: auto;
    padding-bottom: 2rem;
}

@media (max-width: 768px) {
    .subtitle {
        font-size: 1.1rem;
    }

    .analytics-list {
        font-size: 0.95rem;
    }
}
</style>
